import { A11yModule } from "@angular/cdk/a11y";
import { CommonModule } from "@angular/common";
import { inject, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { BiTranslateDirective, BiTranslatePipe } from "@globals/bi-translate";
import { BiConfirmDialogComponent } from "@globals/components/bi-confirm-dialog/bi-confirm-dialog.component";
import { BiPhoneInputComponent } from "@globals/components/bi-phone-input/bi-phone-input.component";
import BiZipCodeInputComponent from "@globals/components/bi-zip-code-input/bi-zip-code-input.component";
import { BiSpinnerModule } from "@globals/components/spinner/bi-spinner.module";
import ZipStreetNumberInputComponent from "@globals/components/zip-street-number-input/zip-street-number-input.component";
import { BiAutofocusDirective } from "@globals/directives/bi-autofocus.directive";
import { BiPhoneFormatWithCodePipe } from "@globals/pipes/bi-phone-format-with-code.pipe";
import { GlobalPipesModule } from "@globals/pipes/global-pipes.module";
import { SubscriptionToIconPipe } from "@globals/pipes/subscription-to-icon.pipe";
import { BiDialogBaseService } from "@globals/services/bi-dialog-base.service";
import { BiDomService } from "@globals/services/bi-dom.service";
import { BiLocalizationHelperBaseService } from "@globals/services/bi-localization-helper-base.service";
import { SubscribeModuleBaseService } from "@globals/services/bi-subscribe-module-base.service";
import { BiToastNotificationService } from "@globals/services/bi-toast-notification.service";
import { BiSkipLinkComponent } from "@iframeModulesShared/components/bi-skip-link/bi-skip-link.component";
import { NgxCaptchaModule } from "ngx-captcha";
import { ConfirmationService } from "primeng/api";
import { AutoCompleteModule } from "primeng/autocomplete";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DividerModule } from "primeng/divider";
import { InputTextModule } from "primeng/inputtext";
import { PanelModule } from "primeng/panel";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { CreateAddressSubscriptionComponent } from "./create-address-subscription/create-address-subscription.component";
import { CreateSupplyNumberSubscriptionComponent } from "./create-supply-number-subscription/create-supply-number-subscription.component";
import { IframeSubscriptionComponent } from "./iframe-subscription.component";
import { SubscriptionModuleSharedService } from "./subscription-module-shared.service";
import { AriaUnsubscribeTextPipe } from "./subscription-overview/aria-unsubscribe-text.pipe";
import { SubscriptionOverviewComponent } from "./subscription-overview/subscription-overview.component";

const primeModules = [ButtonModule, PanelModule, InputTextModule, AutoCompleteModule, CardModule, ProgressSpinnerModule, DividerModule];

@NgModule({
  declarations: [IframeSubscriptionComponent, SubscriptionOverviewComponent, CreateAddressSubscriptionComponent, AriaUnsubscribeTextPipe],
  imports: [
    RouterModule.forChild([{ path: "", component: IframeSubscriptionComponent }]),
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BiTranslatePipe,
    BiTranslateDirective,
    BiSpinnerModule,
    ...primeModules,
    BiZipCodeInputComponent,
    GlobalPipesModule,
    BiPhoneFormatWithCodePipe,
    BiConfirmDialogComponent,
    BiPhoneInputComponent,
    NgxCaptchaModule,
    ZipStreetNumberInputComponent,
    SubscriptionToIconPipe,
    ConfirmDialogModule,
    A11yModule,
    CreateSupplyNumberSubscriptionComponent,
    BiSkipLinkComponent,
    BiAutofocusDirective
  ],
  providers: [SubscriptionModuleSharedService, BiLocalizationHelperBaseService, SubscribeModuleBaseService, ConfirmationService, BiDialogBaseService, BiToastNotificationService, BiDomService]
})
export default class IframeSubscriptionModule {
  // Dynamically load necessary styles here. The bundles are configured inside angular.json to NOT be auto-injected.
  constructor() {
    const domService = inject(BiDomService);
    domService.loadStyle("primeIcons.css");
    domService.loadStyle("ngx-toastr.css");
  }
}
